var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.portal!='kiosk')?_c('div',[_c('basic-user-dashboard')],1):_vm._e(),(_vm.portal=='kiosk')?_c('div',[_c('kiosk-user-dashboard')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }